module.exports = __webpack_public_path__ + "img/Avatar-10.b21ea62d.svg";